import { Toaster as Sonner, toast } from "sonner"

const Toaster = ({ ...props }) => {
  return (
    <Sonner
      theme="dark"
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-[#11121B] group-[.toaster]:text-[#F5F5F5] group-[.toaster]:border-white/10 group-[.toaster]:shadow-lg",
          description: "group-[.toast]:text-[#A1A1AA]",
          actionButton:
            "group-[.toast]:bg-[#6373FA] group-[.toast]:text-white",
          cancelButton:
            "group-[.toast]:bg-[#31344E] group-[.toast]:text-[#A1A1AA]",
        },
      }}
      {...props}
    />
  );
};

export { Toaster, toast }
